import type { GridColDef } from "@mui/x-data-grid";

import type { ClinicPartnerPatient } from "api/services/clinic_partner/schemas/dashboard";

const UTF8_BOM = String.fromCharCode(0xfeff);

const escapeCell = (value: unknown): string => {
  if (value === null || value === undefined) return "";
  const str = String(value);
  const sanitized = /^[=+\-@\t]/.test(str) ? `'${str}` : str;
  if (/[",\n\r]/.test(sanitized)) {
    return `"${sanitized.replace(/"/g, '""')}"`;
  }
  return sanitized;
};

export const buildCsv = (rows: ClinicPartnerPatient[], columns: GridColDef[]): string => {
  const header = columns.map(col => escapeCell(col.headerName ?? col.field));
  const body = rows.map(row =>
    columns.map(col => {
      const rawValue = (row as Record<string, unknown>)[col.field];
      const formatter = col.valueFormatter as ((value: unknown) => unknown) | undefined;
      const formatted = formatter ? formatter(rawValue) : rawValue;
      return escapeCell(formatted);
    })
  );
  return [header, ...body].map(cells => cells.join(",")).join("\n");
};

export const downloadCsv = (csv: string, fileName: string): void => {
  const blob = new Blob([UTF8_BOM, csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
